export default {"theme":{"themes":{"light":{"primary":"#DB3539","secondary":"#000","accent":"#8c9eff","error":"#b71c1c"}}}}
